// FilterCreate/index.jsx
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import TuiEditor from '../../../components/common/TuiEditor';
import styles from './FilterCreate.module.css';
import exampleImg from '../../../assets/filter/exampleImg.svg';
import axios from 'axios';
import { API_BASE_URL } from '../../../apiConfig';
import { storage } from '../../../firebase'; 
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';

export default function FilterCreate() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [link, setLink] = useState('');
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(exampleImg);
  const fileInputRef = useRef(null);

  // 썸네일 미리보기
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnailFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setThumbnailPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // 썸네일 선택
  const handleSelectFile = () => {
    fileInputRef.current.click();
  };

  // URL 유효성 검사
  const isValidUrl = (string) => {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  };

  // Firebase에 이미지 업로드 및 URL 가져오기
  const uploadImageToFirebase = async (file) => {
    if (!file) return null;
    const uniqueFileName = `${uuidv4()}_${file.name}`; // 고유한 파일명 생성
    const storageRef = ref(storage, `filter-images/${uniqueFileName}`); // Firebase Storage 참조 생성
    
    try {
      const snapshot = await uploadBytes(storageRef, file); // 파일 업로드
      const url = await getDownloadURL(snapshot.ref); // 다운로드 URL 가져오기
      console.log('이미지 업로드 성공, URL:', url);
      return url;
    } catch (error) {
      console.error('Firebase 이미지 업로드 실패:', error);
      throw new Error('이미지 업로드 실패');
    }
  };

  // 필터 생성 핸들러 (TuiEditor에서 제목과 내용을 받음)
  const handleFilterSubmit = async (editorContent, editorTitle) => {
    // 제목은 TuiEditor에서 처리하므로 editorTitle 사용
    if (!editorTitle || !editorTitle.trim()) {
      alert('제목을 입력해주세요.');
      return Promise.reject(new Error('제목이 필요합니다.'));
    }

    if (link.trim() && !isValidUrl(link.trim())) {
      alert('올바른 URL 형식으로 입력해주세요. (예: https://example.com)');
      return Promise.reject(new Error('유효하지 않은 URL입니다.'));
    }

    setIsSubmitting(true);
    let imageUrl = '';

    try {
    //   const convertBase64 = (file) => {
    //     return new Promise((resolve, reject) => {
    //       const reader = new FileReader();
    //       reader.readAsDataURL(file);
    //       reader.onload = () => resolve(reader.result);
    //       reader.onerror = (error) => reject(error);
    //     });
    //   };

      // let base64Image = null;
      // if (thumbnailFile) {
      //   base64Image = await convertBase64(thumbnailFile);
      // }

      // 썸네일 파일이 존재하면 Firebase에 업로드
      if (thumbnailFile) {
        imageUrl = await uploadImageToFirebase(thumbnailFile);
      }

      const filterData = {
        productName: editorTitle.trim(),  // TuiEditor에서 받은 제목 사용
        content: editorContent,
        image: imageUrl, // 문자열 전송 (우선은 빈문자열 서버로 전송)
        link: link.trim() || null
      };

      const response = await axios.post(`${API_BASE_URL}/api/v1/admin/new-filter`, filterData);

      if (response.data.code === 1) {
        alert('필터가 성공적으로 생성되었습니다.');
        navigate('/filters');
        return true;
      } else {
        alert('필터 생성에 실패했습니다.');
        return Promise.reject(new Error('생성 실패'));
      }
    } catch (error) {
      console.error('필터 생성 오류:', error);
      alert('오류가 발생했습니다. 다시 시도해주세요.');
      return Promise.reject(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.formSection}>
        <div className={styles.thumbnailSection}>
          <div className={styles.thumbnailPreview}>
            <img
              src={thumbnailPreview}
              alt="썸네일 미리보기"
              className={styles.previewImage}
            />
          </div>
          <div className={styles.thumbnailControls}>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleThumbnailChange}
              accept="image/*"
              style={{ display: 'none' }}
            />
            <button
              type="button"
              className={styles.fileSelectButton}
              onClick={handleSelectFile}
            >
              썸네일 이미지 선택
            </button>
            <p className={styles.thumbnailHelp}>
              권장 크기: 300 X 300 픽셀, 최대 2MB (PNG, JPG, JPEG)
            </p>
          </div>
        </div>

        {/* 링크 입력 섹션 */}
        <div className={styles.linkSection}>
          <label htmlFor="purchaseLink" className={styles.label}>
            구매 링크
          </label>
          <input
            id="purchaseLink"
            type="url"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="구매 페이지 URL을 입력해주세요 (예: https://shop.example.com/product/123)"
            className={styles.linkInputField}
          />
          <p className={styles.inputHelp}>
            제품을 구매할 수 있는 페이지 링크를 입력하세요. (선택사항)
          </p>
        </div>
      </div>
      
      <div className={styles.editorSection}>
        <TuiEditor onSubmit={handleFilterSubmit} isSubmitting={isSubmitting} />
      </div>
    </div>
  );
}